import { ApiProperty } from '@nestjs/swagger';
import { IsOptional } from 'class-validator';
import { Type } from 'class-transformer';

import { SpConnectBuilderTotalQuanityDto } from './sp-connect-builder-total-quantity.dto';
import { SpConnectItemInterface } from '../interfaces/sp-connect-item.interface';

export class SpConnectItemDto implements SpConnectItemInterface {
  @ApiProperty()
  @IsOptional()
  builderAltItemID?: string;

  @ApiProperty()
  @IsOptional()
  itemDescription?: string;

  @ApiProperty()
  @IsOptional()
  @Type(() => SpConnectBuilderTotalQuanityDto)
  builderTotalQuantity?: SpConnectBuilderTotalQuanityDto;
}
